import { Controller } from "@hotwired/stimulus"

// Submits the form on change — e.g. a <select> that navigates a turbo-frame.
// (Unlike autosave, this performs a real form submission/navigation rather
// than a background .json save.)
export default class extends Controller {
    submit() {
        this.element.requestSubmit()
    }
}
